import * as angular from 'angular';
import {IController} from "angular";


export class BringozCountdownServiceAdapterCtrl implements IController {
  from: number;
  to: number;
  statusUpdatedAt: number;
  countToStart: boolean;
  keepCountWhenNegative: boolean;
  stopCount: boolean;
  maxCount: any;

  public selectedClass: string;

  private colorsIntervalRef: any;

  //color classes
  private afterTimeWindowClass = 'late';
  private endOfTimeWindowClass = 'end-of-time-window';
  private startOfTimeWindowClass = 'start-of-time-window';

  constructor(private moment) {
  }

  $onInit() {
    this.selectedClass = '';
  }

  $postLink() {
    this.changeColors();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (
      changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this.changeColors();
    }
  }

  onTimeChanged() {
    this.changeColors(true);
  }

  private changeColors(doUpdate?) {
    if (!!doUpdate || !this.countToStart) {
      const middleOfTimeWindow = (this.moment(this.to).valueOf() - this.moment(this.from).valueOf()) / 2;
      const currentTimeStamp = this.statusUpdatedAt ? this.statusUpdatedAt : this.moment().valueOf();

      this.selectedClass = currentTimeStamp >= this.to ? this.afterTimeWindowClass :
        currentTimeStamp >= this.from + middleOfTimeWindow ? this.endOfTimeWindowClass :
          currentTimeStamp >= this.from ? this.startOfTimeWindowClass : '';
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('bringozCountdownServiceAdapter', {
    bindings: {
      from: '<',
      to: '<',
      countToDate: '<?',
      statusUpdatedAt: '<?',
      countToStart: '<?',
      keepCountWhenNegative: '<?',
      stopCount: '<?',
      maxCount: '<?',
    },
    template: require('./bringoz-countdown-service-adapter.html').default,
    controller: BringozCountdownServiceAdapterCtrl
  });
